import React, { useState, useEffect, useContext } from 'react';
import { createMuiTheme, Container, CssBaseline, Toolbar, IconButton, Typography, FormControlLabel, Checkbox, Backdrop, CircularProgress, Fab, Grid, Snackbar, AppBar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { HttpService } from "../../../apiAuthorization/httpService";
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(styles);

export default function UserModuleList(props) {
    const { theme } = useContext(Theme);
    const classes = useStyles();
    const userName = props.model.length === 0 ? "" : props.model.userName;
    const userGroup = props.model.length === 0 ? "" : props.model.userGroup;
    const [userModules, setUserModules] = useState([]);
    const [checked, setChecked] = useState([]);
    const [trainingChecked, setTrainingChecked] = useState([]);
    const [backDrop, setBackDrop] = useState(true);
    const [modified, setModified] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (rowIndex) => {
        return { color: currentTheme.text, background: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };  

    const closeUserModule = () => {
        props.parentCallback();
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const setFixedGroupUserModule = (item, checked) => {
        let selectedIndex = userModules.findIndex(obj => obj.AppModuleId === item.AppModuleId);
        userModules[selectedIndex].checked = checked;
        setUserModules(userModules);
        setModified(true);
    };

    const setTrainingUserModule = (item, checked) => {
        let selectedIndex = userModules.findIndex(obj => obj.AppModuleId === item.AppModuleId);
        userModules[selectedIndex].UserInTrainingMode = checked;
        setUserModules(userModules);
        setModified(true);
    };

    const contains = (list, obj) => {
        var count = list.length;
        while (count--) {
            if (list[count] === obj) {
                return true;
            }
        }
        return false;
    };

    const saveUserModules = () => {
        if (modified && userName) {
            let selectedUserModules = [];
            userModules.forEach(function (item, index) {
                if (item.checked)
                    selectedUserModules.push({ AppModuleId: item.AppModuleId, ModuleName: item.ModuleName, Original: true, IsTrainingMode: item.IsTrainingMode, TrainingMode: item.UserInTrainingMode });
            });

            if (selectedUserModules.length > 0) {
                setBackDrop(true);
                HttpService.post('/User/AssignModulesToUser', {
                    Username: userName,
                    Modules: selectedUserModules
                })
                    .then((result) => {
                        setBackDrop(false);
                        closeUserModule();
                    },
                        (error) => {
                            console.log(error);
                        });
            }
            else {
                setErrorMessage("Please select at least one module.");
                setOpenError(true);
            }
        }
        else {
            closeUserModule();
        }
    };

    const getUserModuleGroups = (moduleData) => {
        HttpService.post('/User/GetAppModuleGroups', { AppUserName: userName })
        .then((result) => {
            var data = result.data;
            if (data) {
                var moduleGroups = [];
                var groupModules = [];
                var fixedGroups = [];
                var item = [];
                var groupId = 0;
                var index = 0;

                for (index = 0; index < data.length; index++) {
                    moduleGroups.push({
                        AppModuleGroupId: data[index].AppModuleGroupId,
                        AppModuleGroupName: data[index].AppModuleGroupName
                    });
                }
                for (index = 0; index < moduleGroups.length; index++) {
                    if (moduleGroups[index].AppModuleGroupName === userGroup) {
                        groupId = moduleGroups[index].AppModuleGroupId;
                    }
                }

                if (groupId > 0) {
                    HttpService.post("/User/GetAppModulesByGroupId", { GroupId: groupId })
                    .then((result) => {
                        var list = result.data;
                        if (list) {
                            for (index = 0; index < list.length; index++) {
                                fixedGroups.push(list[index].ModuleName);
                            }
                        }
                        for (index = 0; index < moduleData.length; index++) {
                            item = moduleData[index];
                            if (contains(fixedGroups, item.ModuleName))
                                groupModules.push({ checked: true, IsTrainingMode: item.IsTrainingMode, UserInTrainingMode: item.TrainingMode, AppModuleId: item.AppModuleId, ModuleName: item.ModuleName, fixedGroup: true });
                            else
                                groupModules.push({ checked: item.modulesOfUser, IsTrainingMode: item.IsTrainingMode, UserInTrainingMode: item.TrainingMode, AppModuleId: item.AppModuleId, ModuleName: item.ModuleName, fixedGroup: false });
                        }
                        setUserModules(groupModules);
                        setBackDrop(false);
                    });
                }
                else {
                    for (index = 0; index < moduleData.length; index++) {
                        item = moduleData[index];
                        groupModules.push({ checked: item.modulesOfUser, IsTrainingMode: item.IsTrainingMode, UserInTrainingMode: item.TrainingMode, AppModuleId: item.AppModuleId, ModuleName: item.ModuleName, fixedGroup: false });
                    }
                    setUserModules(groupModules);
                    setBackDrop(false);
                }
            }
        },
        (error) => {
            console.log(error);
        });
    };

    const getUserModules = () => {
        HttpService.post('/User/GetAppModulesNotOfUser', { AppUserName: userName })
        .then((result) => {
            var data = result.data;
            if (data) {
                getUserModuleGroups(data);
            }
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getUserModules();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="userModuleBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                        <Alert onClose={closeErrorSnackbar} severity="error">
                            {errorMessage}
                        </Alert>
                    </Snackbar>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={saveUserModules} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>User Modules</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={closeUserModule}>
                                        <CloseIcon />
                                    </Fab>
                                    <SmallMenu modified={modified} saveCallback={() => saveUserModules()} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <div className="react-bootstrap-table" style={{ overflowY: "auto", scrollBehavior: "smooth", position: "absolute", top: "15px", bottom: "15px", left: "15px", right: "15px" }}>
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}>#</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "50px" }}></th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground, width: "200px", textAlign: "center" }}>Training</th>
                                                <th style={{ color: currentTheme.headerColor, background: currentTheme.headerBackground }}>Name</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-capitalize">
                                            {userModules?.map((item, index) => (
                                                <tr key={item.AppModuleId}>
                                                    <td style={rowStyle(index)}>{index + 1}</td>
                                                    <td style={rowStyle(index)}>
                                                        <FormControlLabel
                                                            label=""
                                                            control={<Checkbox
                                                                name={"chk" + item.AppSettingMenuId}
                                                                checked={item.checked}
                                                                disabled={item.fixedGroup}
                                                                onChange={(e) => setChecked({ ...checked, [e.target.name] : e.target.checked })}
                                                                onClick={e => setFixedGroupUserModule(item, e.target.checked)}
                                                                color="primary"
                                                                style={{ paddingTop: "0px", paddingBottom: "0px" }}
                                                            />}
                                                        />
                                                    </td>
                                                    <td style={rowStyle(index)}>
                                                        {item.IsTrainingMode && (
                                                        <FormControlLabel
                                                            label=""
                                                            control={<Checkbox
                                                                name={"chkTraining" + item.AppSettingMenuId}
                                                                checked={item.UserInTrainingMode}
                                                                disabled={!(item.checked)}
                                                                onChange={(e) => setTrainingChecked({ ...trainingChecked, [e.target.name] : e.target.checked })}
                                                                onClick={e => setTrainingUserModule(item, e.target.checked)}
                                                                color="primary"
                                                                style={{ paddingTop: "0px", paddingBottom: "0px", paddingLeft: "92px" }}
                                                            />}
                                                        />)}
                                                    </td>
                                                    <td style={rowStyle(index)}>{item.ModuleName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    }

    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
